import { Grid, Switch, Typography } from '@mui/material';
import styled from 'styled-components';

export const CustomWrapper = styled(Grid)`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-content: flex-start;
  margin: 0;
  padding: 0;
`;

export const CustomGrid = styled(Grid)`
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding: 20px 0;
  margin-bottom: 30px;
`;

export const CustomLabel = styled(Typography)`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  margin-left: 10px;
`;

export const CustomReserveTimeLabelDisabled = styled(Typography)`
  font-family: 'Roboto', sans-serif;
  margin: 13px 0px 0px 45px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
`;

export const CustomSwitch = styled(Switch)`
  margin: 5px 10px;
`;

export const CustomTypography = styled(Typography)`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  padding: 0 0 5px;
`;

export const CustomTypographyWhenPreCheckoutEnabled = styled(Typography)`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: left;
  padding: 0px 0px 0px 45px;
`;
